// extracted by mini-css-extract-plugin
export default {"fullscreen":"RowLayoutFullscreenContent_fullscreen__LO0jn","placeHolderShimmer":"RowLayoutFullscreenContent_placeHolderShimmer__AHiVt"};